import { QueryFunctionContext } from '@tanstack/react-query'
import { DELETE, GET, POST, PUT } from '../../../redux/middleware/types'
import integrationRequest from '../../../services/api/integrationRequest'
import sourceMapEndpoints from '../api/sourceMapEndpoints'
import sourceMapQueryKeys from '../queries/sourceMapQueryKeys'
import { SourceMap, SourceMapPayload, SourceMapSuggestion } from '../types'

export const getSourceMaps = async ({
  queryKey: [{ companyId, source, localEntity, sourceEntity }],
  signal
}: QueryFunctionContext<ReturnType<(typeof sourceMapQueryKeys)['list']>>): Promise<SourceMap[]> => {
  if (!companyId) return []
  return integrationRequest<SourceMap[]>({
    method: GET,
    url: sourceMapEndpoints.list(),
    signal,
    params: { companyId, source, localEntity, sourceEntity }
  })
}

export const getSourceMapSuggestions = async ({
  queryKey: [{ companyId, source, localEntity, sourceEntity }],
  signal
}: QueryFunctionContext<ReturnType<(typeof sourceMapQueryKeys)['suggestions']>>): Promise<SourceMapSuggestion[]> => {
  if (!companyId) return []
  return integrationRequest<SourceMapSuggestion[]>({
    method: GET,
    url: sourceMapEndpoints.suggestions(),
    signal,
    params: { companyId, source, localEntity, sourceEntity }
  })
}

export const createSourceMap = async (payload: SourceMapPayload): Promise<SourceMap> =>
  integrationRequest<SourceMap>({
    method: POST,
    url: sourceMapEndpoints.list(),
    data: payload
  })

export const updateSourceMap = async (id: number, payload: SourceMapPayload): Promise<SourceMap> =>
  integrationRequest<SourceMap>({
    method: PUT,
    url: sourceMapEndpoints.detail(id),
    data: payload
  })

export const deleteSourceMap = async (id: number): Promise<void> =>
  integrationRequest<void>({
    method: DELETE,
    url: sourceMapEndpoints.detail(id)
  })
